export default __webpack_public_path__ + "static/media/Cotidiano_favelado_4.7e71f646.jpg";